import {ConfigurableRedirectService} from "./service/ConfigurableRedirectService";
import {RedirectServiceModule} from "./RedirectServiceModuleConfiguration";

RedirectServiceModule
    .createNewModule()
    .service('ConfigurableRedirectService', ['$http', ConfigurableRedirectService]);